module.exports = __webpack_public_path__ + "static/media/props.cd8bacc8.svg";